import { HttpInterceptorFn } from '@angular/common/http';

import {
    apiVersioningInterceptor,
    connectionLostInterceptor,
    pendingRequestsInterceptor,
    provideDuplicateBetplacementInterceptor,
    sessionExpirationInterceptor,
} from '@frontend/sports/http/feature';

export function provideSportsHttpInterceptors(): HttpInterceptorFn[] {
    return [
        sessionExpirationInterceptor,
        apiVersioningInterceptor,
        connectionLostInterceptor,
        pendingRequestsInterceptor,
        provideDuplicateBetplacementInterceptor(),
    ];
}
